// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8ff8c6a0","239":"cd3d1597","455":"a7b701d2","726":"26be5dbc"}[chunkId] + ".chunk.js";
};